import { SystemState } from '../storeTypes';

export const getProfileState = (state: SystemState) => {
  return state.profile;
};
